export default "__VITE_ASSET__Bpfmf6qE__"